import shopImg from "../assets/shopImg.png";
import infoImg from "../assets/infoImg.png";
import seekverImg from "../assets/seekverImg.png";
import catGallery from "../assets/catgallery.png";
import foodbank from "../assets/Hackathon_foodbank.png";
import wordGuessingGame from "../assets/wordguessinggame.png";
import expenseTracker from "../assets/expensetracker.png";

const ProjectCardData = [
  {
    imgsrc: infoImg,
    title: "Community Info Board -- MERN Full Stack Web Project",
    text: "It is a responsive website in which users can post, edit, read and delete any info on the board. All information on the board are related to some free or low cost services provided around the community",
    view: "https://communityinfo.onrender.com/",
    github: "https://github.com/chunyim/CommunityInfo",
  },
  {
    imgsrc: shopImg,
    title: "Online Shopping Web App -- React Web Project",
    text: "It is a responsive and user-friendly platform designed to allow the user to browse differnt products easily via search.",
    view: "https://shopping-project-gold.vercel.app/",
    github: "https://github.com/chunyim/product-app",
  },
  {
    imgsrc: seekverImg,
    title: "Seekver Website -- MEAN Stack Project",
    text: "It is a dynamic and user-friendly platform designed to connect problem seekers with skilled solvers. The website will keep updating with the vision of becoming the ultimate destination for individuals seeking solutions and those equipped with the expertise to deliver them.",
    view: "https://seekver.netlify.app",
    github: "https://github.com/chunyim/Seekver-Frontend",
  },
  // {
  //   imgsrc: expenseTracker,
  //   title: "Expense Tracker Web App -- MERN Stack Project",
  //   text: "It is a full stack web app designed to help users to track their expenses and incomes with data visualization",
  //   view: "https://github.com/chunyim/expense-tracker",
  //   github: "https://github.com/chunyim/expense-tracker",
  // },
  // {
  //   imgsrc: foodbank,
  //   title: "WIMTACH 2-day Front-End Hackathon",
  //   text: "A web and mobile application designed to facilitate food delivery between food banks and the community, while also offering a convenient search feature for finding suitable food bank providers. Key features include Responsive Design, Reusable UI/UX components, HTML5-qrcode and Chat Bot",
  //   view: "https://github.com/hinilyu/foodbank",
  //   github: "https://github.com/hinilyu/foodbank",
  // },
  {
    imgsrc: catGallery,
    title: "Cat Gallery -- Front-End JS Project",
    text: "It is a gallery utilizing the cat API to fetch cat images, where users can select their favorite photos, and a maximum of 9 cat pictures will be saved.",
    view: "https://cat-gallery-chunhin.netlify.app",
    github: "https://github.com/chunyim/catgallery",
  },
  // {
  //   imgsrc: wordGuessingGame,
  //   title: "Word Guessing Game -- Front-End JS Project",
  //   text: "It is a word guessing game where users can make as many attempts as they want until they win!",
  //   view: "https://comp125-guessing-game.netlify.app/",
  //   github: "https://github.com/chunyim/guessing-game",
  // },
];

export default ProjectCardData;
